import { createAPIHeaders, fetchUtility } from '.';
import { UploadReason } from '../../types/generic';

const createUploadReason = (uploadReason: UploadReason): Record<string, string> => {
	const uploadReasonObj: Record<string, string> = {
		uploadReasonMessage: uploadReason.reason,
	};
	if (uploadReason.onBehalfOf && uploadReason.onBehalfOfEmail && uploadReason.onBehalfOfName) {
		uploadReasonObj['uploadReasonName'] = uploadReason.onBehalfOfName;
		uploadReasonObj['uploadReasonEmail'] = uploadReason.onBehalfOfEmail;
	}

	return uploadReasonObj;
};

export const logUploadStarted = async (
	apiKey: string,
	operationName: string,
	fileName: string,
	uploadSizeBytes: number,
	userName: string,
	userTeam: string,
	userEmail: string,
	uploadId: string,
	uploadReason: UploadReason,
	suspectKnown?: boolean
): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/pipeline/logUploadStarted/${operationName}/${fileName}`, {
		headers: createAPIHeaders(apiKey, 'POST'),
		method: 'POST',
		body: JSON.stringify({
			uploadSizeBytes,
			userName,
			userTeam,
			userEmail,
			uploadId,
			suspectKnown: suspectKnown || suspectKnown === false ? String(suspectKnown) : 'N/A',
			...createUploadReason(uploadReason),
		}),
	});
};

export const logUploadCompleted = async (apiKey: string, operationId: string, fileName: string, uploadId: string): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/pipeline/logUploadCompleted/${operationId}/${fileName}`, {
		headers: createAPIHeaders(apiKey, 'POST'),
		method: 'POST',
		body: JSON.stringify({
			uploadId,
		}),
	});
};

export const logProcessingStarted = async (
	apiKey: string,
	operationId: string,
	fileName: string,
	uploadReason: UploadReason,
	fileId: string,
	userName: string,
	userTeam: string,
	userEmail: string,
	suspectKnown?: boolean,
	wordListName?: string,
	wordListModified?: string,
	notifyOnComplete?: boolean,
	selectedMapping?: string
): Promise<Response> => {
	return fetchUtility(`${import.meta.env.VITE_API_URL}/pipeline/logProcessingStarted/${operationId}/${fileName}`, {
		headers: createAPIHeaders(apiKey, 'POST'),
		method: 'POST',
		body: JSON.stringify({
			userName,
			userTeam,
			userEmail,
			wordListName: wordListName || 'N/A',
			wordListModified: wordListModified || 'N/A',
			suspectKnown: suspectKnown || suspectKnown === false ? String(suspectKnown) : 'N/A',
			processingId: fileId,
			selectedMapping: selectedMapping,
			notifyOnComplete: notifyOnComplete || false,
			...createUploadReason(uploadReason),
		}),
	});
};
